import React, { useEffect, useState } from "react";
import { getSettings } from "@/lib/api";
import { MessageCircle } from "lucide-react";

const FloatingWhatsApp = () => {
  const [wa, setWa] = useState("");

  useEffect(() => {
    getSettings().then((s) => setWa((s.shop_whatsapp || "").replace(/\D/g, ""))).catch(() => {});
  }, []);

  if (!wa) return null;

  return (
    <a
      href={`https://wa.me/${wa}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-40 w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white shadow-xl hover:shadow-2xl flex items-center justify-center transition-transform hover:scale-105 print:hidden"
      style={{ boxShadow: "0 12px 28px -8px rgba(16, 185, 129, 0.55)" }}
    >
      <MessageCircle className="w-7 h-7" strokeWidth={2} />
      <span className="sr-only">WhatsApp</span>
    </a>
  );
};

export default FloatingWhatsApp;
